
export default function (){
    return{
        methods: {

            getformatDate(value) {
                if (value) {
                    return Intl.DateTimeFormat('fr-FR', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"
                    }).format(new Date(value));
                }
            },
            myFunction() {
                var input, filter, table, tr, td, i, txtValue;
                input = document.getElementById("myInput");
                filter = input.value.toUpperCase();
                table = document.getElementById("myTable");
                tr = table.getElementsByTagName("tr");
                let number_found = 0;
                for (i = 0; i < tr.length; i++) {
                    td = tr[i].getElementsByTagName("td")[0];
                    let tab_tr = tr[i].getElementsByTagName("td");
                    let found = false;
                    for (let j = 0; j < tab_tr.length; j++) {
                        if (tab_tr[j]) {
                            txtValue = tab_tr[j].textContent || tab_tr[j].innerText;
                            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                                found = true;
                                break;
                            }
                        }
                    }
                        if (found) {
                            tr[i].style.display = "";
                            number_found ++;
                        } else {
                            tr[i].style.display = "none";
                        }

                }
                let not_found_text = document.getElementById("not_found_text");
                if (number_found>0){
                    not_found_text.style.display = "none";
                } else{
                    not_found_text.style.display = "";
                }

            },
            async myFunction1() {
                var input, filter, table, tr, td, i, txtValue;
                input = document.getElementById("myInput");
                filter = input.value.toUpperCase();
                table = document.getElementById("myTable1");
                tr = table.getElementsByTagName("tr");
                let number_found = 0;
                for (i = 0; i < tr.length; i++) {
                    td = tr[i].getElementsByTagName("td")[0];
                    let tab_tr = tr[i].getElementsByTagName("td");
                    let found = false;
                    for (let j = 0; j < tab_tr.length; j++) {
                        if (tab_tr[j]) {
                            txtValue = tab_tr[j].textContent || tab_tr[j].innerText;
                            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                                found = true;
                                break;
                            }
                        }
                    }
                        if (found) {
                            tr[i].style.display = "";
                            number_found ++;
                        } else {
                            tr[i].style.display = "none";
                        }

                }
                return number_found;
                /* let not_found_text = document.getElementById("not_found_text");
                if (number_found>0){
                    not_found_text.style.display = "none";
                } else{
                    not_found_text.style.display = "";
                } */

            },
            async myFunction2() {
                var input, filter, table, tr, td, i, txtValue;
                input = document.getElementById("myInput");
                filter = input.value.toUpperCase();
                table = document.getElementById("myTable2");
                tr = table.getElementsByTagName("tr");
                let number_found = 0;
                for (i = 0; i < tr.length; i++) {
                    td = tr[i].getElementsByTagName("td")[0];
                    let tab_tr = tr[i].getElementsByTagName("td");
                    let found = false;
                    for (let j = 0; j < tab_tr.length; j++) {
                        if (tab_tr[j]) {
                            txtValue = tab_tr[j].textContent || tab_tr[j].innerText;
                            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                                found = true;
                                break;
                            }
                        }
                    }
                        if (found) {
                            tr[i].style.display = "";
                            number_found ++;
                        } else {
                            tr[i].style.display = "none";
                        }

                }
                return number_found;
                /* let not_found_text = document.getElementById("not_found_text");
                if (number_found>0){
                    not_found_text.style.display = "none";
                } else{
                    not_found_text.style.display = "";
                } */

            },
            async myFunction3() {
                var input, filter, table, tr, td, i, txtValue;
                input = document.getElementById("myInput");
                filter = input.value.toUpperCase();
                table = document.getElementById("myTable3");
                tr = table.getElementsByTagName("tr");
                let number_found = 0;
                for (i = 0; i < tr.length; i++) {
                    td = tr[i].getElementsByTagName("td")[0];
                    let tab_tr = tr[i].getElementsByTagName("td");
                    let found = false;
                    for (let j = 0; j < tab_tr.length; j++) {
                        if (tab_tr[j]) {
                            txtValue = tab_tr[j].textContent || tab_tr[j].innerText;
                            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                                found = true;
                                break;
                            }
                        }
                    }
                        if (found) {
                            tr[i].style.display = "";
                            number_found ++;
                        } else {
                            tr[i].style.display = "none";
                        }

                }
                return number_found;
                /* let not_found_text = document.getElementById("not_found_text");
                if (number_found>0){
                    not_found_text.style.display = "none";
                } else{
                    not_found_text.style.display = "";
                } */

            },
            async myFunction4() {
                var input, filter, table, tr, td, i, txtValue;
                input = document.getElementById("myInput");
                filter = input.value.toUpperCase();
                table = document.getElementById("myTable4");
                tr = table.getElementsByTagName("tr");
                let number_found = 0;
                for (i = 0; i < tr.length; i++) {
                    td = tr[i].getElementsByTagName("td")[0];
                    let tab_tr = tr[i].getElementsByTagName("td");
                    let found = false;
                    for (let j = 0; j < tab_tr.length; j++) {
                        if (tab_tr[j]) {
                            txtValue = tab_tr[j].textContent || tab_tr[j].innerText;
                            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                                found = true;
                                break;
                            }
                        }
                    }
                        if (found) {
                            tr[i].style.display = "";
                            number_found ++;
                        } else {
                            tr[i].style.display = "none";
                        }

                }
                return number_found;
                /* let not_found_text = document.getElementById("not_found_text");
                if (number_found>0){
                    not_found_text.style.display = "none";
                } else{
                    not_found_text.style.display = "";
                } */

            },
            async myFunction5() {
                var input, filter, table, tr, td, i, txtValue, thead;
                input = document.getElementById("myInput");
                filter = input.value.toUpperCase();
                table = document.getElementById("myTable5");
                tr = table.getElementsByTagName("tr");

                let number_found = 0;
                for (i = 0; i < tr.length; i++) {
                    td = tr[i].getElementsByTagName("td")[0];
                    let tab_tr = tr[i].getElementsByTagName("td");
                    let found = false;
                    for (let j = 0; j < tab_tr.length; j++) {
                        if (tab_tr[j]) {
                            txtValue = tab_tr[j].textContent || tab_tr[j].innerText;
                            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                                found = true;
                                break;
                            }
                        }
                    }
                        if (found) {
                            tr[i].style.display = "";
                            number_found ++;
                        } else {
                            tr[i].style.display = "none";
                        }

                }
                return number_found;
                /* let not_found_text = document.getElementById("not_found_text");
                if (number_found>0){
                    not_found_text.style.display = "none";
                } else{
                    not_found_text.style.display = "";
                } */

            },

        }
    }

}


export function confirmAction(type = 'create') {
    const config = {
        cancel: {
            title: 'Annuler les modifications',
            text: 'Les modifications non enregistrées seront perdues. Continuer ?',
            icon: 'warning',
            confirmButtonText: 'Quitter',
            cancelButtonText: 'Rester'
        },
        create: {
            title: 'Confirmation',
            text: 'Voulez-vous vraiment créer cet élément ?',
            type: 'info',
            confirmButtonText: 'Créer',
            cancelButtonText: 'Annuler'
        },
        edit: {
            title: 'Confirmation',
            text: 'Voulez-vous vraiment enregistrer les modifications ?',
            type: 'warning',
            confirmButtonText: 'Modifier',
            cancelButtonText: 'Annuler'
        },
        delete: {
            title: 'Confirmation',
            text: 'Cette action supprimera définitivement l\'élément. Continuer ?',
            type: 'warning',
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler'
        },
        validate: {
            title: 'Confirmation',
            text: 'Valider cette opération ?',
            type: 'info',
            confirmButtonText: 'Valider',
            cancelButtonText: 'Annuler'
        },
        reject: {
            title: 'Rejet de l\'achat',
            text: 'Voulez-vous vraiment rejeter cet achat ?',
            type: 'warning',
            confirmButtonText: 'Rejeter',
            cancelButtonText: 'Annuler'
        }
    };

    const settings = config[type] || config['create'];

    return new Promise((resolve) => {
        swal({
            title: settings.title,
            text: settings.text,
            type: settings.type,
            showCancelButton: true,
            confirmButtonText: settings.confirmButtonText,
            cancelButtonText: settings.cancelButtonText,
            closeOnConfirm: true,
            closeOnCancel: true
        }, function(isConfirm) {
            resolve({ confirmed: isConfirm });
        });
    });
}


export function showValidationErrors(err) {
    const response = err?.response || err;
    const data = response?.data;

    console.group("🔍 Erreur interceptée");
    console.error("Erreur complète :", err);
    console.error("Contenu de la réponse :", data);
    console.groupEnd();

    // ✅ 1. Erreurs de validation classiques (formulaires)
    if (data?.errors && typeof data.errors === 'object') {
        const errorMessages = Object.values(data.errors)
            .flat()
            .map(msg => `• ${msg}`)
            .join('\n');

        swal('Erreur de validation', errorMessages, 'error');
        return;
    }

    // ✅ 2. Cas spécial : produits en rupture de stock
    if (data?.products && Array.isArray(data.products)) {
        const productList = data.products
            .map(p => `• ${p.name} (${p.code})`)
            .join('\n');

        swal({
            icon: "error",
            title: "Stock insuffisant",
            text: `${data.message || "Certains produits sont en rupture de stock :"}\n\n${productList}`,
            buttons: true
        });
        return;
    }

    // ✅ 3. Message brut (string)
    if (typeof data === 'string') {
        swal('Erreur', data, 'error');
        return;
    }

    // ✅ 4. Message JSON standard
    if (data?.message) {
        swal('Erreur', data.message, 'error');
        return;
    }

    // ❌ 5. Fallback
    swal('Erreur', 'Une erreur inconnue est survenue.', 'error');
}

export function _chunkArray(arr, size = 100) {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
}


